<template>
  <div class="bg-white p-4">
    <div class="flex justify-between items-center my-3">
      <div>
        <h2 class="text-2xl font-semibold">List of Donors</h2>
      </div>
      <base-button
        outline
        type="primary"
        class="flex px-3 py-1 mx-1"
        @click="handleOpen"
      >
        <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Add Donor
      </base-button>
    </div>
    <DonorTable ref="getDonor" />
    <b-modal
      modal-content-classes="cust-modal-ht"
      header-bg-variant="primary"
      header-text-variant="white"
      id="add-donor"
      title="Add Donor"
      hide-footer
    >
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(handleCreate)">
          <div class="mt-4">
            <FileUploader
              v-show="!image"
              :image="image"
              :onSuccess="handleSuccess"
              accept="image"
              class="rounded-full widtht30percent m-auto display-none custmodal"
            />
            <img
              v-if="image"
              :src="image"
              ref="cover"
              class="rounded-full widtht30percent m-auto display-none custmodal"
            />
            <div
              class="text-center text-red"
              v-if="image"
              @click="handleRemove"
            >
              Remove image
            </div>
            <p class="text-center">Upload your cover photo</p>
            <span v-if="imageErr" class="small text-danger">{{
              msg.image
            }}</span>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Name</p>
            <base-input
              v-model="name"
              placeholder="Enter donor name"
              class="md:border-0 lg:border-0 custipshadow"
              name="Name"
              :rules="{ required: true, regex: /^[A-Za-z\s]+$/ }"
              @input="
                name = name.replace(/[^A-Za-z\s]/g, '').replace(/\s{2,}/g, ' ')
              "
            ></base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Type</p>
            <b-form-select
              v-model="type"
              placeholder="Select"
              class="w-full"
              required
            >
              <b-form-select-option
                v-for="item in typeOptions"
                class="py-5"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </b-form-select-option>
            </b-form-select>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Page to show Donor</p>
            <b-form-select
              v-model="category"
              placeholder="Select"
              class="w-full"
              required
            >
              <b-form-select-option
                v-for="item in pageOptions"
                class="py-5"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </b-form-select-option>
            </b-form-select>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">Plan</p>
            <b-form-select
              v-model="plan"
              placeholder="Select"
              class="w-full"
              required
            >
              <template v-if="type == '' || type == 'individual'">
                <b-form-select-option
                  v-for="item in planOptions1"
                  class="py-5"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </b-form-select-option>
              </template>
              <template v-if="type == 'corporate'">
                <b-form-select-option
                  v-for="item in planOptions2"
                  class="py-5"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </b-form-select-option>
              </template>
            </b-form-select>
          </div>
          <div class="flex justify-center">
            <b-button
              class="font-semibold"
              type="primary"
              native-type="submit"
              variant="primary"
              >Save</b-button
            >
            <!-- <b-button
              class="font-semibold"
              variant="primary"
              @click="closeModal('add-donor')"
              >Close</b-button
            > -->
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import FileUploader from "../../../../components/FileUploader.vue";
import DonorTable from "./components/donorTable.vue";
export default {
  components: {
    DonorTable,
    FileUploader,
  },
  data() {
    return {
      name: "",
      plan: "",
      type: "",
      category: "",
      image: null,
      coverImage: null,
      imageErr: false,
      audioErr: false,
      msg: {
        image: "",
        audio: "",
      },
      pageOptions: [
        { name: "Donation Page", value: "Donation Page" },
        { name: "FOCGS Page", value: "FOCGS Page" },
      ],
      typeOptions: [
        { name: "Individual", value: "individual" },
        { name: "Corporate", value: "corporate" },
      ],
      planOptions1: [
        { name: "Compassion Supporter", value: "Compassion Supporter" },
        { name: "Caregiver Champion", value: "Caregiver Champion" },
        { name: "Angel of Care", value: "Angel of Care" },
      ],
      planOptions2: [
        {
          name: "Corporate Compassion Partner",
          value: "Corporate Compassion Partner",
        },
        { name: "CSR Caregiver Advocate", value: "CSR Caregiver Advocate" },
        {
          name: "Caregiver's Champion Partner",
          value: "Caregiver's Champion Partner",
        },
      ],
    };
  },
  methods: {
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    async handleCreate() {
      // if (this.coverImage === null) {
      //   await this.$swal({
      //     text: "Please upload cover photo!",
      //     icon: "warning",
      //     showCancelButton: false,
      //     confirmButtonColor: "#830c81",
      //   });
      //   return;
      // }
      const payload = new FormData();
      payload.append("name", this.name);
      payload.append("plan", this.plan);
      payload.append("type", this.type);
      payload.append("category", this.category);
      payload.append("image", this.coverImage);
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch("services/createDonor", payload);
        if (data.code == 200) {
          this.$swal.fire({
            text: " Successfully Added",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        this.$refs.getDonor.getDonorList();
        this.reset();
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    reset() {
      this.$bvModal.hide("add-donor");
      this.name = "";
      this.type = "";
      this.image = null;
      this.category = "";
      this.coverImage = null;
      this.plan = "";
    },
    handleOpen(data) {
      this.name = "";
      this.type = "";
      this.category = "";
      this.image = null;
      this.coverImage = null;
      this.plan = "";
      this.$bvModal.show("add-donor");
    },
  },
  async mounted() {},
};
</script>

<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 10px !important;
}

.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.form-group {
  margin-bottom: 0.5rem;
}
input.is-invalid ~ .custom-file-label {
  border-color: #cad1d7;
}
.widtht30percent {
  width: 30%;
  height: 140px !important;
}
</style>
